import React from "react"

import ErrorHandlerService from "@/services/ErrorHandler"
import FallbackScreen from "@/components/GlobalErrorBoundary/FallbackScreen"

type GlobalErrorBoundaryState = {
	hasError: boolean
}

type GlobalErrorBoundaryProps = {
	children: React.ReactNode
}

class GlobalErrorBoundary extends React.Component<GlobalErrorBoundaryProps, GlobalErrorBoundaryState> {
	state: GlobalErrorBoundaryState = {
		hasError: false
	}

	static getDerivedStateFromError (): State {
		return { hasError: true }
	}

	componentDidCatch (error: Error): void {
		ErrorHandlerService.handle(error)
	}

	handleReset = (): void => {
		window.location.reload()
	}

	render () {
		if (this.state.hasError) {
			return <FallbackScreen onReset={this.handleReset} />
		}

		return this.props.children
	}
}

export default GlobalErrorBoundary
